// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__kDzS5","file":"styles_file__294dJ"};